import { Scalars } from '@bechtel/types';
import styled, { css } from 'styled-components';
import { Box, Button, IconStyled, TextFieldStyled, inputMediumStyles, Icon } from '@bechtel/gds';
import { SearchField } from '@bechtel/client-common';
import { NavLink } from 'react-router-dom';
import { listWidth, smallScreenListWidth } from '~/components/organisms/weld-search-drawer';

interface WeldListContainerStyledProps {
  isDrawerOpen: Scalars['Boolean'];
}

export const WeldListContainerStyled = styled.div<WeldListContainerStyledProps>`
  background-color: ${({ theme }) => theme.colors.white};
  display: flex;
  flex-direction: column;
  height: 100vh;
  left: 0;
  position: absolute;
  top: 0;
  width: ${listWidth};

  /* Z-index required to show box shadow on top of drawer when the drawer is open as drawer has z-index of 1.  */
  ${(props) =>
    props.isDrawerOpen &&
    css`
      z-index: 2;
    `}

  @media only screen and (max-width: ${({ theme }) => theme.breakpoints.widescreen}) {
    width: ${smallScreenListWidth};
  }
  box-shadow: 0 3px 5px -1px rgba(0, 0, 0, 0.2), 0 1px 18px 0 rgba(0, 0, 0, 0.12), 0 6px 10px 0 rgba(0, 0, 0, 0.14);
  color: ${({ theme }) => theme.colors.grey[1000]};
  &::before {
    box-shadow: 14px 0 12px -8px rgba(0, 0, 0, 0.1);
    content: '';
    height: 100%;
    pointer-events: none;
    position: absolute;
    right: 0;
    width: 32px;
  }
`;

export const ListStyled = styled.div`
  overflow-y: auto;
  flex-grow: 1;
`;

export const NavLinkStyled = styled(NavLink)`
  ${({ theme }) => css`
    border-radius: ${theme.radii[200]};
    border-bottom: 1px solid ${theme.colors.grey[300]};
    color: inherit;
    display: block;
    padding-top: ${theme.spacings[500]};
    padding-left: ${theme.spacings[300]};
    padding-right: ${theme.spacings[500]};
    padding-bottom: ${theme.spacings[500]};
    position: relative;
    text-decoration: none;
    transition-timing-function: ease-in-out;
    transition-duration: 80ms;
    transition-property: background-color;
    @media only screen and (max-width: ${theme.breakpoints.widescreen}) {
      padding-top: ${theme.spacings[450]};
      padding-bottom: ${theme.spacings[450]};
    }
    &:active,
    &.active,
    &:hover {
      background-color: ${theme.colors.bechtel.blue[100]};
    }
  `}
`;

export const StyledIcon = styled(Icon)`
  ${({ theme }) => css`
    @media only screen and (max-width: ${theme.breakpoints.widescreen}) {
      & > svg {
        height: ${theme.fontSizes[500]};
      }
    }
  `}
`;

export const WeldDetailContainerStyled = styled(Box).attrs({
  flexDirection: { sm: 'column' },
  alignItems: { sm: 'center' },
  justifyContent: { sm: 'center' },
})`
  ${({ theme }) => css`
    position: absolute;
    left: ${listWidth};
    overflow-y: auto;
    height: 100%;
    width: calc(100% - ${listWidth});
    background-color: ${theme.colors.white};
    @media only screen and (max-width: ${theme.breakpoints.widescreen}) {
      left: ${smallScreenListWidth};
      width: calc(100% - ${smallScreenListWidth});
    }
  `}
`;

export const WeldListHeader = styled.div`
  padding: ${({ theme }) => theme.spacings[400]};
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.2), 0 2px 1px -1px rgba(0, 0, 0, 0.12), 0 1px 1px 0 rgba(0, 0, 0, 0.14);
  z-index: 1;
`;

export const SearchFieldStyled = styled(Box).attrs({
  mb: { sm: '400' },
  alignItems: { sm: 'center' },
  justifyContent: { sm: 'center' },
})`
  ${IconStyled} {
    right: ${({ theme }) => theme.spacings[500]};
  }
  ${TextFieldStyled} {
    ${({ theme }) => css`
      font-size: ${theme.fontSizes[400]};
      border-color: ${theme.colors.grey[300]};
      font-family: 'Graphik';
    `}
  }
`;

export const SearchFieldComponentStyled = styled(SearchField)`
  @media only screen and (max-width: ${({ theme }) => theme.breakpoints.widescreen}) {
    ${inputMediumStyles}
  }
`;

interface SearchCanvasButtonStyledProps {
  isDefaultFilterChange: Scalars['Boolean'];
}
export const SearchCanvasButtonStyled = styled(Button)<SearchCanvasButtonStyledProps>`
  @media only screen and (max-width: ${({ theme }) => theme.breakpoints.widescreen}) {
    ${inputMediumStyles}
  }
  ${(props) =>
    props.isDefaultFilterChange &&
    css`
      background-color: ${({ theme }) => theme.colors.bechtel.blue[700]};
      &:hover {
        background-color: ${({ theme }) => theme.colors.bechtel.blue[700]};
      }
    `}
`;
